import { pdfjs } from 'react-pdf';
import { BUILD_URLS } from 'reactApp/appHelpers/configHelpers';

const pathToWorker = `${BUILD_URLS?.js}pdfWorker.js`;

pdfjs.GlobalWorkerOptions.workerSrc = pathToWorker;
